// extracted by mini-css-extract-plugin
module.exports = {"center":"SignupVerify_center__2xW4_","resendCode":"SignupVerify_resendCode__OvrL2"};